import { type MutableRefObject, useState, useRef, useEffect } from "react";
import type { EngineWithSpecsType } from "../utils/compareTypes";
import { useCompareV2Selector } from "../redux/store";
import { NcCompareContext } from "../../../common-deprecated/types/NewCarCompareTypes";

type HookReturnType = {
    hasMultipleEngines: boolean;
    open: boolean;
    setOpen: (val: boolean) => void;
    dropDownRef: MutableRefObject<HTMLButtonElement | null>;
};

const useSelectEngine = (
    engines: EngineWithSpecsType[],
    engineSelectHeight: number,
    setEngineSelectHeight: (height: number) => void,
): HookReturnType => {
    const [open, setOpen] = useState<boolean>(false);
    const dropDownRef = useRef<HTMLButtonElement>(null);
    const isLeasing = useCompareV2Selector(
        (state) => state.newCarCompare.ncCompareContext === NcCompareContext.Leasing,
    );

    const setHeight = (newHeight: number): void => {
        if (newHeight > engineSelectHeight) {
            setEngineSelectHeight(newHeight);
        }
    };

    useEffect(() => {
        if (dropDownRef.current) {
            setHeight(dropDownRef.current.offsetHeight);
        }
    });

    return {
        // There is always one configured engine in leasing
        hasMultipleEngines: engines?.length > 1 && !isLeasing,
        open,
        dropDownRef,
        setOpen: (val: boolean) => setOpen(val),
    };
};

export default useSelectEngine;
